import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '../../store';

export interface lightboxState {
    isOpen: boolean;
    currentIndex: number;
    images: any[];
}

const initialState: lightboxState = {
    isOpen: false,
    currentIndex: 0,
    images: [],
}

export const lightboxSlice = createSlice({
    name: 'lightbox',
    initialState,
    reducers: {
        show: (state) => {
            state.isOpen = true
        },
        hide: (state) => {
            state.isOpen = false
        },
        setImages: (state, action: PayloadAction<any[]>) => {
            state.images = action.payload
        },
        setCurrentIndex: (state, action:PayloadAction<number>) => {
            state.currentIndex = action.payload
        },
        moveNext: (state) => {
            state.currentIndex++
        },
        movePrev: (state) => {
            state.currentIndex--
        },
    }
})

export const { show, hide, setImages, setCurrentIndex, movePrev, moveNext } = lightboxSlice.actions

export const lightbox = (state: RootState) => state.lightbox

export const isOpen = (state: RootState) => state.lightbox.isOpen;

export const images = (state: RootState) => state.lightbox.images;


export default lightboxSlice.reducer